<template>
  <transition name="fade-in-up">
    <router-view></router-view>
  </transition>
</template>

<style lang="scss" scoped>
@import '~bootstrap-vue/dist/bootstrap-vue.css';
</style>

<script>
import { SET_MENU } from '@/core/services/store/modules/menu.module';
import { SideBar } from '@/core/config/menu/sideBar';

export default {
  mounted() {
    this.applyMenuByRoute();
  },
  watch: {
    '$route.path': {
      immediate: true,
      handler() {
        this.applyMenuByRoute();
      },
    },
  },
  methods: {
    applyMenuByRoute() {
      const path = String(this.$route?.path || '');
      // Purchase Request nằm dưới STOCK sidebar
      if (path.startsWith('/budget/purchase-requests')) {
        this.$store.dispatch(SET_MENU, SideBar.STOCK);
        return;
      }
      // Các màn ngân sách/cost-items/cost-groups nằm dưới ACCOUNTANT
      this.$store.dispatch(SET_MENU, SideBar.ACCOUNTANT);
    },
  },
};
</script>
